(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const sizeSelect = document.getElementById('size');
    const lengthSelect = document.getElementById('length-inch');
    const addToCartBtn = document.querySelector('button[name="add"]');
    const buyNowBtn = document.querySelector('.shopify-payment-button__button');
    const productForm = document.querySelector('product-form-component');
    const isSoldOut = productForm && productForm.getAttribute('data-sold-out') === 'true';

    function validateForm() {
      if (isSoldOut) {
        if (addToCartBtn) addToCartBtn.disabled = true;
        if (buyNowBtn) buyNowBtn.disabled = true;
        return;
      }
      const sizeValid = sizeSelect && sizeSelect.value;
      // Only require length if present (i.e. ABAYAS)
      const lengthValid = !lengthSelect || lengthSelect.value;
      const enable = sizeValid && lengthValid;
      if (addToCartBtn) addToCartBtn.disabled = !enable;
      if (buyNowBtn) buyNowBtn.disabled = !enable;
    }

    if (sizeSelect) sizeSelect.addEventListener('change', validateForm);
    if (lengthSelect) lengthSelect.addEventListener('change', validateForm);

    // Initial state
    validateForm();
  });
  } catch(e) { console.error(e); }
})();

})();
